module.exports = __webpack_public_path__ + "img/merchanto-api-v2.85e12c2f.svg";